import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { submitCreateIntegration } from '~/api/data/integrations/mutations';
import { loadIntegration, loadIntegrations } from '~/api/data/integrations/queries';
import { loadCurrentUser } from '~/api/data/users/queries';
import {
  IntegrationConnectPage,
  IntegrationManagePage,
  SettingsIntegrationsPage
} from '~/pages/settings/integrations';

export const integrationsRoute: RouteObject = {
  path: 'integrations',
  loader: merge({
    integrations: loadIntegrations,
    agencyUser: loadCurrentUser
  }),
  element: <SettingsIntegrationsPage />,
  children: [
    {
      path: 'connect/:type',
      action: byMethod({
        POST: submitCreateIntegration
      }),
      element: <IntegrationConnectPage />
    },
    {
      path: 'manage/:id',
      loader: merge({ integration: loadIntegration, integrations: loadIntegrations }),
      element: <IntegrationManagePage />
    }
  ]
};
